export default "__VITE_ASSET__b9c7d36e__"